/* TRYNOTTOGURT theme — no libraries. */
(function () {
  'use strict';
  const T = window.TNTG || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = T.moneyFormat || '${{amount}}';
    const n = (cents || 0) / 100;
    const withDelims = (num, dec, th, de) => {
      const [a, b] = num.toFixed(dec).split('.');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (b ? de + b : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    });
  }
  T.money = money;

  /* ---------- toast ---------- */
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toast.t); toast.t = setTimeout(() => t.classList.remove('on'), 2800);
  }

  /* ---------- panels ---------- */
  let lastFocus = null;
  function openPanel(id) {
    closeAll(true);
    const el = document.getElementById(id); if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    if (id !== 'search') $('#scrim').classList.add('on');
    document.body.classList.add('lock');
    if (id === 'search') setTimeout(() => { const q = $('#search input'); q && q.focus(); }, 150);
    else setTimeout(() => { const b = el.querySelector('button'); b && b.focus(); }, 150);
    if (id === 'drawer') refreshCart();
  }
  function closeAll(silent) {
    ['menu', 'search', 'drawer'].forEach(id => {
      const el = document.getElementById(id); if (!el) return;
      el.classList.remove('on'); el.setAttribute('aria-hidden', 'true');
    });
    const s = $('#scrim'); s && s.classList.remove('on');
    document.body.classList.remove('lock');
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- cart ---------- */
  const B = T.bundle || { enabled: false };
  const packSaving = price => Math.round(price * (B.percent || 0) / 100);

  async function api(url, body) {
    const opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    const r = await fetch(url, opts);
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Try again.');
    return j;
  }
  function setCount(n) { $$('.cart-n').forEach(el => { el.textContent = n; el.dataset.n = n; }); }

  async function refreshCart() {
    try { renderCart(await api(T.routes.cart + '.js')); } catch (e) { /* keep last state */ }
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    const body = $('#lines'), foot = $('#drfoot');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty"><p>Your cart is empty.</p><a class="btn" href="${T.routes.all}">Shop tees</a></div>`;
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((it, k) => {
      const opts = (it.options_with_values || []).filter(o => o.value !== 'Default Title').map(o => esc(o.value)).join(' / ');
      const img = it.image ? `<img src="${esc(it.image)}${it.image.includes('?') ? '&' : '?'}width=200" alt="" loading="lazy" width="84" height="105">` : '';
      const was = it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : '';
      return `<div class="line">
        <a class="thumb" href="${esc(it.url)}">${img}</a>
        <div>
          <div class="line-top"><a class="line-name" href="${esc(it.url)}">${esc(it.product_title)}</a><span class="line-price">${was}${money(it.final_line_price)}</span></div>
          ${opts ? `<div class="line-meta">${opts}</div>` : ''}
          <div class="line-bot">
            <div class="stepper sm"><button type="button" data-act="line-qty" data-line="${k + 1}" data-q="${it.quantity - 1}" aria-label="Decrease quantity">${T.icons.minus}</button><output>${it.quantity}</output><button type="button" data-act="line-qty" data-line="${k + 1}" data-q="${it.quantity + 1}" aria-label="Increase quantity">${T.icons.plus}</button></div>
            <button type="button" class="rm" data-act="line-qty" data-line="${k + 1}" data-q="0">Remove</button>
          </div>
        </div></div>`;
    }).join('');

    const disc = cart.items.reduce((s, it) => s + (it.line_level_discount_allocations || []).reduce((a, d) => a + d.amount, 0), 0)
      + (cart.cart_level_discount_applications || []).reduce((a, d) => a + d.total_allocated_amount, 0);
    const titles = [...new Set([].concat(...cart.items.map(it => (it.line_level_discount_allocations || []).map(d => d.discount_application.title)),
      (cart.cart_level_discount_applications || []).map(d => d.title)))].filter(Boolean);
    const q = B.qty || 2, left = B.enabled ? (q - cart.item_count % q) % q : 0;
    const sample = cart.items[0] ? cart.items[0].final_price + 0 : 0;
    const hint = left && sample ? `<p class="deal-hint">Add ${left === 1 ? 'one more tee' : left + ' more tees'} and save ${money(packSaving(cart.items[0].original_price))} with the ${q}-tee deal.</p>` : '';
    foot.querySelector('.dr-sum').innerHTML = hint
      + (disc ? `<div class="deal"><span>${esc(titles.join(', ') || 'Discount')}</span><span>−${money(disc)}</span></div>` : '')
      + `<div class="sub"><span>Subtotal</span><span>${money(cart.total_price)} ${esc(cart.currency)}</span></div>`;
  }

  async function addItems(items, open = true) {
    const r = await api(T.routes.cartAdd + '.js', { items });
    await refreshCart();
    if (open) openPanel('drawer');
    return r;
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    const data = JSON.parse($('script[data-product-json]', root).textContent);
    const ci = data.options.findIndex(n => /colou?r/i.test(n));
    const si = data.options.findIndex(n => /size/i.test(n));
    const colours = ci > -1 ? [...new Set(data.variants.map(v => v.options[ci]))] : [null];
    const sizes = si > -1 ? [...new Set(data.variants.map(v => v.options[si]))] : [null];
    const single = data.variants.length === 1 && data.variants[0].options[0] === 'Default Title';
    const first = data.variants.find(v => v.available) || data.variants[0];
    const st = {
      pack: 1, qty: 1,
      sel: [0, 1].map(() => ({ colour: ci > -1 ? first.options[ci] : null, size: single ? '_' : null }))
    };
    const findVariant = s => single ? data.variants[0] : data.variants.find(v =>
      (ci < 0 || v.options[ci] === s.colour) && (si < 0 || v.options[si] === s.size) &&
      data.options.every((_, i) => i === ci || i === si || v.options[i] === first.options[i]));
    const sizeAvail = (colour, size) => data.variants.some(v => (ci < 0 || v.options[ci] === colour) && v.options[si] === size && v.available);
    const chosen = () => st.sel.slice(0, st.pack);
    const allSized = () => chosen().every(s => s.size);
    const unitPrice = () => { const v = st.sel[0].size ? findVariant(st.sel[0]) : null; return (v || first).price; };
    const swatch = name => (T.swatches || {})[String(name).toLowerCase()] || '#ccc';

    const opts = $('#opts', root), priceEl = $('#pprice', root), err = $('#err', root), buyRow = $('#buyrow', root);

    function optBlock(i) {
      const s = st.sel[i], multi = st.pack > 1, lab = multi ? ` for shirt ${i + 1}` : '';
      let h = `<div class="optset" data-i="${i}">${multi ? `<div class="optset-h">Shirt ${i + 1}</div>` : ''}`;
      if (ci > -1) {
        h += `<div class="opt-label">${esc(data.options[ci])} <span class="col-l">${esc(s.colour)}</span></div>`;
        if (colours.length > 1) h += `<div class="chips" role="group" aria-label="${esc(data.options[ci])}${lab}">${colours.map(c =>
          `<button type="button" class="chip" data-act="colour" data-i="${i}" data-v="${esc(c)}" aria-pressed="${c === s.colour}"><i style="background:${swatch(c)}"></i>${esc(c)}</button>`).join('')}</div>`;
      }
      if (si > -1) {
        h += `<div class="opt-label">${esc(data.options[si])} ${i === 0 && T.hasSizeGuide ? '<button type="button" class="ulink" data-act="open-guide">Size guide</button>' : ''}</div>
        <div class="sizes" data-i="${i}" role="group" aria-label="${esc(data.options[si])}${lab}">${sizes.map(z => {
          const ok = sizeAvail(s.colour, z);
          return `<button type="button" data-act="size" data-i="${i}" data-v="${esc(z)}" aria-pressed="${z === s.size}" ${ok ? '' : 'disabled'}>${esc(z)}${ok ? '' : '<span class="sr"> sold out</span>'}</button>`;
        }).join('')}</div>`;
      }
      return h + '</div>';
    }
    function renderPrice() {
      const p = unitPrice();
      if (st.pack > 1) {
        const full = p * st.pack, pack = full - packSaving(p) * Math.floor(st.pack / 2);
        priceEl.innerHTML = `${money(pack)} <s><span class="sr">Was </span>${money(full)}</s> <small>${esc(T.currency)} for ${st.pack}</small>`;
      } else {
        const v = st.sel[0].size ? findVariant(st.sel[0]) : first;
        const cmp = v && v.compare > v.price ? ` <s><span class="sr">Was </span>${money(v.compare)}</s>` : '';
        priceEl.innerHTML = `${money(p)}${cmp} <small>${esc(T.currency)}</small>`;
      }
      const pk = $$('.pack', root);
      if (pk.length) {
        $('.pk-price', pk[0]).textContent = money(p);
        const full = p * B.qty;
        $('.pk-was', pk[1]).innerHTML = `<span class="sr">Was </span>${money(full)}`;
        $('.pk-price', pk[1]).textContent = money(full - packSaving(p));
        $('.pk-foot', pk[1]).textContent = `Save ${money(packSaving(p))}`;
      }
    }
    function renderOpts() {
      opts.innerHTML = single ? '' : Array.from({ length: st.pack }, (_, i) => optBlock(i)).join('');
      buyRow.classList.toggle('single', st.pack > 1);
      $$('[data-act="pack"]', root).forEach(x => x.setAttribute('aria-pressed', +x.dataset.n === st.pack));
      err.textContent = '';
      renderPrice(); renderSticky();
    }
    function renderSticky() {
      const s = $('#sticky'); if (!s) return;
      const s0 = st.sel[0];
      const meta = st.pack > 1 ? `${st.pack} tees` : [s0.colour, s0.size !== '_' ? s0.size : null].filter(Boolean).map(esc).join(' / ');
      s.innerHTML = `<div><b>${esc(data.title)}</b><span class="muted">${meta}</span></div>
        <button type="button" class="btn" data-act="atc">${allSized() ? 'Add to cart' : 'Select size'}</button>`;
    }
    function showColour(c) {
      const v = data.variants.find(x => x.options[ci] === c && x.media);
      if (!v) return;
      const slide = $(`.slide[data-media="${v.media}"]`, root);
      if (!slide) return;
      const tr = $('#track', root);
      if (getComputedStyle(tr).display === 'grid') { if (tr.firstElementChild !== slide) tr.prepend(slide); }
      else tr.scrollTo({ left: slide.offsetLeft - tr.offsetLeft - parseFloat(getComputedStyle(tr).paddingLeft), behavior: 'smooth' });
    }
    function needSize() {
      const i = chosen().findIndex(s => !s.size);
      err.textContent = st.pack > 1 ? `Select a size for shirt ${i + 1} to continue.` : 'Select a size to continue.';
      const s = $(`.sizes[data-i="${i}"]`, root); if (!s) return;
      s.classList.remove('shake'); void s.offsetWidth; s.classList.add('shake');
      s.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    async function buy(now, btn) {
      if (!allSized()) return needSize();
      const items = chosen().map(s => findVariant(s)).map(v => ({ id: v && v.id, quantity: st.pack > 1 ? 1 : st.qty }));
      if (items.some(i => !i.id)) { err.textContent = 'That combination is unavailable. Pick another size.'; return; }
      const merged = []; items.forEach(i => { const m = merged.find(x => x.id === i.id); m ? m.quantity += i.quantity : merged.push(i); });
      const b = btn || $('#atc', root); const label = b.textContent; b.disabled = true; b.textContent = 'Adding…';
      try {
        await addItems(merged, !now);
        if (now) window.location.href = T.routes.checkout;
      } catch (e) { err.textContent = e.message; }
      finally { b.disabled = false; b.textContent = label; }
    }

    root.addEventListener('click', e => {
      const t = e.target.closest('[data-act]'); if (!t || !root.contains(t)) return;
      const i = +t.dataset.i;
      switch (t.dataset.act) {
        case 'pack': st.pack = +t.dataset.n; renderOpts(); break;
        case 'colour': {
          st.sel[i].colour = t.dataset.v;
          if (st.sel[i].size && !sizeAvail(st.sel[i].colour, st.sel[i].size)) st.sel[i].size = null;
          const set = t.closest('.optset'); set.outerHTML = optBlock(i);
          showColour(t.dataset.v); renderPrice(); renderSticky(); break;
        }
        case 'size':
          st.sel[i].size = t.dataset.v; err.textContent = '';
          t.closest('.sizes').querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', b === t));
          renderPrice(); renderSticky(); break;
        case 'qty-dec': st.qty = Math.max(1, st.qty - 1); $('#qty', root).textContent = st.qty; break;
        case 'qty-inc': st.qty = Math.min(20, st.qty + 1); $('#qty', root).textContent = st.qty; break;
        case 'atc': e.preventDefault(); buy(false, t); break;
        case 'buy': e.preventDefault(); buy(true, t); break;
        case 'open-guide': { const g = $('#guide', root); if (g) { g.open = true; g.scrollIntoView({ behavior: 'smooth', block: 'start' }); } break; }
        case 'dot': {
          const tr = $('#track', root), s = tr.children[+t.dataset.n];
          tr.scrollTo({ left: s.offsetLeft - tr.offsetLeft - parseFloat(getComputedStyle(tr).paddingLeft), behavior: 'smooth' });
          break;
        }
      }
    });
    $('#sticky') && $('#sticky').addEventListener('click', e => { if (e.target.closest('[data-act="atc"]')) buy(false, e.target.closest('button')); });

    const tr = $('#track', root);
    tr && tr.addEventListener('scroll', () => {
      const w = tr.firstElementChild ? tr.firstElementChild.offsetWidth + 8 : 1, n = Math.round(tr.scrollLeft / w);
      $$('.dots button', root).forEach((d, k) => d.setAttribute('aria-current', k === n));
    }, { passive: true });

    const atc = $('#atc', root), sticky = $('#sticky');
    if (atc && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('on', show); sticky.setAttribute('aria-hidden', !show);
      }).observe(atc);
    }
    renderOpts();
  }

  /* ---------- size guide units ---------- */
  function setUnit(u) {
    $$('[data-cm]').forEach(td => { const cm = parseFloat(td.dataset.cm); td.textContent = u === 'cm' ? Math.round(cm * 10) / 10 : (cm / 2.54).toFixed(1); });
    $$('[data-unit-label]').forEach(el => el.textContent = u);
    $$('[data-act="unit"]').forEach(b => b.setAttribute('aria-pressed', b.dataset.u === u));
  }

  /* ---------- product cards ---------- */
  function resetQuick() {
    $$('.quick.on').forEach(x => { x.classList.remove('on'); x.setAttribute('aria-hidden', 'true'); x.querySelectorAll('button').forEach(b => b.tabIndex = -1); });
    $$('[data-act="quick"]').forEach(b => b.textContent = 'Add To Cart');
  }

  /* ---------- gurt counter ---------- */
  function counter() {
    const el = $('#gurtCount'); if (!el) return;
    let n = 0;
    const tick = () => { n += 1 + Math.floor(Math.random() * 4); el.textContent = n.toLocaleString(); setTimeout(tick, 350 + Math.random() * 1100); };
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) setTimeout(tick, 600);
  }

  /* ---------- global events ---------- */
  document.addEventListener('click', async e => {
    const t = e.target.closest('[data-act]');
    if (!t) { if (!e.target.closest('.quick')) resetQuick(); return; }
    if (t.closest('[data-product-root]') && t.dataset.act !== 'unit') return; // handled by product page
    switch (t.dataset.act) {
      case 'open-menu': e.preventDefault(); openPanel('menu'); break;
      case 'open-search': e.preventDefault(); openPanel('search'); break;
      case 'open-cart': e.preventDefault(); openPanel('drawer'); break;
      case 'close-all': closeAll(); break;
      case 'unit': setUnit(t.dataset.u); break;
      case 'quick': {
        const q = t.closest('.card').querySelector('.quick'), wasOn = q.classList.contains('on');
        resetQuick();
        if (!wasOn) { q.classList.add('on'); q.setAttribute('aria-hidden', 'false'); q.querySelectorAll('button:not([disabled])').forEach(b => b.tabIndex = 0); t.textContent = 'Close'; const f = q.querySelector('button:not([disabled])'); f && f.focus(); }
        break;
      }
      case 'quick-add': {
        t.disabled = true;
        try { await addItems([{ id: +t.dataset.id, quantity: 1 }]); resetQuick(); }
        catch (err) { toast(err.message); }
        finally { t.disabled = false; }
        break;
      }
      case 'line-qty': {
        const body = $('#lines'); body.classList.add('busy');
        try { renderCart(await api(T.routes.cartChange + '.js', { line: +t.dataset.line, quantity: +t.dataset.q })); }
        catch (err) { toast(err.message); }
        finally { body.classList.remove('busy'); }
        break;
      }
    }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeAll(); resetQuick(); } });

  document.addEventListener('DOMContentLoaded', () => {
    $$('[data-product-root]').forEach(initProduct);
    counter();
    if (T.cartType === 'drawer') refreshCart();
  });
})();
